var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22502",
    "data-name": "Group 22502",
    transform: "translate(-27 -487)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7599",
    "data-name": "Rectangle 7599",
    width: 18,
    height: 18,
    transform: "translate(27 487)",
    fill: "#9ff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22501",
    "data-name": "Group 22501",
    transform: "translate(225.065 768.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101763",
    "data-name": "Path 101763",
    d: "M-109.261-252.124l.02.035a1.2,1.2,0,0,0,.923.562h0v-.965l-.566-.258Z",
    transform: "translate(-80.882 -26.049)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101764",
    "data-name": "Path 101764",
    d: "M-94.536-252.492v.965a1.2,1.2,0,0,0,.923-.562l.02-.035-.376-.626Z",
    transform: "translate(-94.393 -26.049)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101765",
    "data-name": "Path 101765",
    d: "M-109.261-252.124l.02.035a1.2,1.2,0,0,0,.923.562h0v-.965l-.566-.258Z",
    transform: "translate(-80.882 -26.049)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101766",
    "data-name": "Path 101766",
    d: "M-122.3-160.95v5.639H-123.9l0-.348.037-5.291-.172,5.311-.014.447h1.866l-.009-.467Z",
    transform: "translate(-67.313 -110.281)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101767",
    "data-name": "Path 101767",
    d: "M-93.613-252.089l.02-.035-.376-.626-.566.258v.965A1.2,1.2,0,0,0-93.613-252.089Z",
    transform: "translate(-94.393 -26.049)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101768",
    "data-name": "Path 101768",
    d: "M-92.961-155.659v-5.291l-.1,5.291-.009.467h1.866l-.015-.467-.171-5.291.037,5.291,0,.348h-1.606Z",
    transform: "translate(-95.735 -110.281)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101769",
    "data-name": "Path 101769",
    d: "M-164.687-155.57l-.353.76.353,3.421.353-3.421Z",
    transform: "translate(-29.702 -115.218)",
    fill: "#fff",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101770",
    "data-name": "Path 101770",
    d: "M-36.37-155.57l-.353.76.353,3.421.353-3.421Z",
    transform: "translate(-147.441 -115.218)",
    fill: "#fff",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101771",
    "data-name": "Path 101771",
    d: "M-107.532-218.614v-1.042h-.872Z",
    transform: "translate(-81.669 -56.415)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101772",
    "data-name": "Path 101772",
    d: "M-109.261-233.366h.942v-.927h-.573Z",
    transform: "translate(-80.882 -42.984)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101773",
    "data-name": "Path 101773",
    d: "M-93.963-234.294h-.573v.927h.942Z",
    transform: "translate(-94.393 -42.984)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101774",
    "data-name": "Path 101774",
    d: "M-94.536-219.656v1.042l.872-1.042Z",
    transform: "translate(-94.393 -56.415)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101775",
    "data-name": "Path 101775",
    d: "M-79.728-91.7l-.4-.29v.519h-1.188l.136,1.248c1.663.167,1.939-.2,1.939-.2a5.948,5.948,0,0,0-.38-1.019C-79.637-91.48-79.678-91.578-79.728-91.7Z",
    transform: "translate(-106.525 -173.556)",
    fill: "#fff",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101776",
    "data-name": "Path 101776",
    d: "M-136.1-91.58v-.529l-.17.184a4.345,4.345,0,0,0-.245.374,5.947,5.947,0,0,0-.38,1.019s.277.368,1.948.2l.135-1.247Z",
    transform: "translate(-55.527 -173.447)",
    fill: "#fff",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101777",
    "data-name": "Path 101777",
    d: "M-110.937-85.693h-1.181c-.059.358-.145,1.42-.145,1.42v.059a1.618,1.618,0,0,0,1.153.4s.1.009.145.007.145-.007.145-.007a1.618,1.618,0,0,0,1.153-.4v-.171c-.024-.283-.088-1.021-.136-1.308Z",
    transform: "translate(-78.128 -179.334)",
    fill: "#fff",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101778",
    "data-name": "Path 101778",
    d: "M-181.778-269.924l-5.025-5.061-1.293-4.752-.97-1.4-.97,1.4-1.293,4.752-5.025,5.061-1.058,1.877.353.546h.294l.588-.261,1.5-.748-.007,0-.176-1.521.47-.938.474.935-.169,1.5,0,.011,1.9.651a57.939,57.939,0,0,1,1.755-9.024,67.5,67.5,0,0,0-1.645,9.029l-.074.04-2.717,2.246,1.217.8,1.683-.995-.185.615.354-.239.278-.188v.523h4.736v-.523l.529.282.274.146-.185-.615,1.683.995,1.217-.8-2.693-2.226v0l-.118-.063a67.5,67.5,0,0,0-1.645-9.029,57.981,57.981,0,0,1,1.756,9.03l1.863-.637-.007,0-.176-1.521.47-.938.474.935-.169,1.5,0,0,1.555.775.588.261h.294l.353-.546Zm-9.584,4.451.014-.447.172-5.311-.037,5.291,0,.348h1.606v-5.639l.1,5.291.009.467Zm2.162-9.556-.872-1.042h.872Zm0-1.321h-.942l.369-.927h.573Zm0-1.226h0a1.2,1.2,0,0,1-.923-.562l-.02-.035.376-.626.566.258Zm0-1.194-.5-.229.5-.965Zm.271-1.194.5.965-.5.229Zm0,1.423.566-.258.376.626-.02.035a1.2,1.2,0,0,1-.923.562Zm0,1.264h.573l.369.927h-.943Zm0,1.207h.872l-.872,1.042Zm1.837,10.13-.037-5.291.171,5.291.015.467h-1.866l.009-.467.1-5.291v5.639h1.606Z",
    fill: "#fff",
    opacity: 0.65
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGame);
export default __webpack_public_path__ + "static/media/menu-game.3719991c78a1565b33ca50d8a6578d8a.svg";
export { ForwardRef as ReactComponent };